import { ReactNode } from "react"

type DepartmentInfoProp = {
  icon: ReactNode | string
  department: string | undefined
}

export const DepartmentInfoCard: React.FC<DepartmentInfoProp> = ({
  icon,
  department,
}) => {
  return (
    <div className="flex items-center gap-1">
      {typeof icon === "string" ? (
        <img
          src={icon}
          width={15}
          height={15}
        />
      ) : (
        icon
      )}
      <p className="text-sm font-circular">{department}</p>
    </div>
  )
}
